import { createFileRoute, redirect } from '@tanstack/react-router'

// The Tasks page replaces this report. It checks no role here: the Tasks page lets
// every member in, and its own gates decide what each one sees.
export const Route = createFileRoute(
  '/_authenticated/_organization/reports/tasks'
)({
  beforeLoad: () => {
    throw redirect({ to: '/tasks', replace: true })
  },
})
